<template>
  <div class="nav">
    <ul class="nav_box">
      <li @click="push_text">
        <img class="img_1" src="../../assets/images/yj.png" alt="" />
        <img class="img_2" src="../../assets/images/yj1.png" alt="" />
      </li>
      <li @mouseenter="list = true" @mouseleave="list = false">
        <img class="img_1" src="../../assets/images/lx1.png" alt="" />
        <img class="img_2" src="../../assets/images/lx.png" alt="" />
      </li>
      <!-- <li @mouseenter="code = true" @mouseleave="code = false">
        <img class="img_1" src="../../assets/images/ewm.png" alt="" />
        <img class="img_2" src="../../assets/images/ewm1.png" alt="" />
      </li> -->
      <li @click="top_btn">
        <img class="img_1" src="../../assets/images/xs.png" alt="" />
        <img class="img_2" src="../../assets/images/xs1.png" alt="" />
      </li>
      <!--   -->
      <div class="list" v-show="list">
        <div class="list_box" style="margin-bottom: 0 !important;">
          <p>
            咨询热线
            <span class="span_right" style="font-size:24px;font-width:600;color:#5B85FF">4006611558</span>
          </p>
        </div>
        <!-- <div class="list_box" style="margin-bottom: 0 !important;">
          <img src="../../assets/images/dh.png" alt="" />
          <p>
            业务咨询

            <span class="span_right">17307112177</span>
          </p>
        </div>
        <div class="list_box" style="margin-bottom: 0 !important">
          <img src="../../assets/images/kf.png" alt="" />
          <p>
            客户服务1

            <span class="span_right">15972005680</span>
          </p>
        </div>
        <div class="list_box" style="margin-bottom: 0 !important;">
          <img src="../../assets/images/kf.png" alt="" />
          <p>
            客户服务2

            <span class="span_right">15972168177</span>
          </p>
        </div> -->
      </div>
      <div class="code" v-show="code">
        <img src="http://www.jeesit.com/img/erweima.png" alt="" />
        <p>微信扫码</p>
        <p>关注杰宜斯云公众号</p>
      </div>
    </ul>
  </div>
</template>
<script>
import "./style.css";
import "@/assets/iconfont/iconfont.css";
export default {
  components: {},
  name: "nnav",
  data() {
    return {
      list: false,
      code: false
    };
  },
  mounted() {},
  methods: {
    push_text() {
      if (localStorage.getItem("token")) {
        this.$router.push("/index/feedback/put");
      } else {
        this.$router.push("/login");
      }
    },
    top_btn() {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/nav/index.vue